import { Component } from 'react';
import ReactSelect from '../../../components/ReactSelect';
import { v4 as uuid } from 'uuid';
import { addUsers, deleteUser, getUsers } from './queries';
import Loading from '../../../components/Loading';
import isEmail from 'validator/lib/isEmail';
import { withTranslation } from 'react-i18next';

class AddUsers extends Component {
    constructor(props) {
        super();

        this.handleChange = this.handleChange.bind(this);
        this.addUserFileds = this.addUserFileds.bind(this);
        this.deleteUserFileds = this.deleteUserFileds.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.checkUsers = this.checkUsers.bind(this);
        this.getName = this.getName.bind(this);
        this.isInvalid = this.isInvalid.bind(this);
        this.getViewers = this.getViewers.bind(this);
        this.onDeleteAlreadyAddedUser = this.onDeleteAlreadyAddedUser.bind(this);

        this.state = {
            users: [
                {
                    id: uuid(),
                    first_name: '',
                    last_name: '',
                    email: '',
                    domains: [],
                    isValid: true,
                },
            ],
            existingUsers: [],
            showEmailErrors: false,
            users_remaining_count: Number(props.users_remaining_count),
            local_users_remaining_count: Number(props.users_remaining_count) - 1,
            deleteLoading: {},
        };
    }

    async getViewers() {
        try {
            const res = await getUsers();
            const data = await res.json();
            const users = data.map((item) => ({
                id: item.id,
                first_name: item.first_name,
                last_name: item.last_name,
                email: item.email,
                domains: [],
                isValid: true,
                isNotEditable: true,
            }));
            this.setState({
                existingUsers: users,
            });
        } catch (err) {
            console.log('err', err);
        }
    }

    async componentDidMount() {
        this.getViewers();
    }

    handleChange(e, id) {
        const users = this.state.users.map((user) => {
            if (user.id === id) {
                return {
                    ...user,
                    [e.target.name]: e.target.value,
                    isValid: e.target.name === 'email' ? isEmail(e.target.value) : user.isValid,
                };
            }
            return user;
        });

        this.setState({
            users,
        });
    }

    addUserFileds() {
        const emptyUser = {
            id: uuid(),
            first_name: '',
            last_name: '',
            email: '',
            domains: [],
            isValid: true,
        };

        this.setState({
            users: [...this.state.users, emptyUser],
            local_users_remaining_count: this.state.local_users_remaining_count - 1,
        });
    }

    deleteUserFileds(id) {
        this.setState({
            users: this.state.users.filter((item) => item.id !== id),
            local_users_remaining_count: this.state.local_users_remaining_count + 1,
        });
    }

    onChangeSelect(id, value) {
        const users = this.state.users.map((user) => {
            if (user.id === id) {
                return { ...user, domains: value.map((item) => item.value) };
            }
            return user;
        });

        this.setState({
            users,
        });
    }

    async onDeleteAlreadyAddedUser(id) {
        try {
            this.setState({
                deleteLoading: {
                    ...this.state.deleteLoading,
                    [id]: true,
                },
            });
            await deleteUser(id);

            this.setState({
                local_users_remaining_count: this.state.local_users_remaining_count + 1,
                users_remaining_count: this.state.users_remaining_count + 1,
                existingUsers: this.state.existingUsers?.filter((item) => item.id !== id),
                deleteLoading: {
                    ...this.state.deleteLoading,
                    [id]: false,
                },
            });
        } catch (err) {
            console.log('err', err);
            this.setState({
                deleteLoading: {
                    ...this.state.deleteLoading,
                    [id]: false,
                },
            });
        }
    }

    isInvalid() {
        const isInvalid = this.state.users.find((item) => !item.isValid);

        this.setState({
            showEmailErrors: !!isInvalid,
        });

        return !!isInvalid;
    }

    async onSubmit(save) {
        try {
            if (!save) return this.props.handleNext();
            if (this.isInvalid()) return;

            this.setState({
                loading: true,
            });

            const res = await addUsers(this.state.users, this.props.csrf_token);
            const data = await res.json();
            console.log('res', res);
            if (res.ok) {
                this.props.onAddUsers(this.state.users.length);
                this.setState({
                    users: [{ id: uuid(), first_name: '', last_name: '', email: '', domains: [] }],
                    loading: false,
                    message: data.result,
                    message_tags: 'success',
                    users_remaining_count: this.state.users_remaining_count - 1,
                    local_users_remaining_count: this.state.local_users_remaining_count - 1,
                });
                this.getViewers();
                this.props.handleNext();
            } else {
                this.setState({
                    loading: false,
                    message: data.detail ?? 'Something went wrong',
                    message_tags: 'error',
                });
            }
        } catch (err) {
            this.setState({
                loading: false,
                message: err.message ?? 'Something went wrong',
                message_tags: 'error',
            });
        }
    }

    checkUsers() {
        let emptyFields = 0;
        let filledFields = 0;

        if (Number(this.state.users_remaining_count) <= 0) {
            return {
                save: false,
                disabled: false,
            };
        }

        this.state.users.forEach((item) => {
            for (let key in item) {
                if (key === 'id' || key === 'isValid') continue;
                if (Array.isArray(item[key]) && !!item[key].length) {
                    filledFields += 1;
                    continue;
                }
                if (!Array.isArray(item[key]) && item[key]) {
                    filledFields += 1;
                    continue;
                }
                emptyFields += 1;
            }
        });

        if (!emptyFields && filledFields)
            return {
                save: true,
                disabled: false,
            };
        if (emptyFields && filledFields)
            return {
                save: true,
                disabled: true,
            };

        return {
            save: false,
            disabled: false,
        };
    }

    getName(save) {
        const { t } = this.props;
        if (save) return t('onboarding.save_and_next');
        return t('onboarding.skip');
    }

    render() {
        const { t } = this.props;

        const localUsersCount =
            this.props.users_total_number_of_available - this.state.local_users_remaining_count;

        const showPluseBtn = localUsersCount < this.props.users_total_number_of_available;

        const options =
            this.props.domains?.map((item) => ({
                label: (
                    <div className="row">
                        <div className="col-11 wrap-text">
                            {' '}
                            {item?.url ?? t('onboarding.step_4.step_4.select_domain')}
                        </div>
                        <div className="col-1">
                            {item?.status ? (
                                <i className="text-success icofont-verification-check"></i>
                            ) : (
                                <i className=" text-danger icofont-ui-close"></i>
                            )}{' '}
                        </div>
                    </div>
                ),
                value: item.pk,
            })) ?? [];

        const { save, disabled } = this.checkUsers();

        return (
            <>
                <div className="mb-10">
                    {this.state.existingUsers?.map((item, i) => (
                        <div key={i} className="settings-linked-accounts-item px-20">
                            <div className="settings-linked-accounts-item-left">
                                <div className="settings-icon-first-letter">
                                    {item?.first_name?.split('')?.[0]}
                                </div>
                                <div className="settings-linked-accounts-item-left-text">
                                    <div>
                                        {item.first_name} {item.last_name}
                                    </div>
                                    {item.email && (
                                        <div className="settings-linked-accounts-item-left-text-bottom users">
                                            {item.email}{' '}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="padding-x-20">
                    <div id="onboarding-step-4">
                        {Number(this.state.users_remaining_count) === 0 &&
                            this.props.users_total_number_of_available === 0 && (
                                <div>You have no free spaces to add new users.</div>
                            )}
                        {Number(this.state.users_remaining_count) > 0 &&
                            this.state.users.map((user, i, arr) => (
                                <div className="onboarding-add-user" key={user.id}>
                                    <div className="onboarding-add-user-field">
                                        <label htmlFor="first_name" className="form-label">
                                            {t('onboarding.step_4.first_name')}
                                        </label>
                                        <input
                                            name="first_name"
                                            id="first_name"
                                            className="form-control"
                                            value={user.first_name}
                                            onChange={(e) => this.handleChange(e, user.id)}
                                        />
                                    </div>

                                    <div className="onboarding-add-user-field">
                                        <label htmlFor="last_name" className="form-label">
                                            {t('onboarding.step_4.last_name')}
                                        </label>
                                        <input
                                            name="last_name"
                                            id="last_name"
                                            className="form-control"
                                            value={user.last_name}
                                            onChange={(e) => this.handleChange(e, user.id)}
                                        />
                                    </div>

                                    <div className="onboarding-add-user-field">
                                        <label htmlFor="email" className="form-label">
                                            {t('onboarding.step_4.email_address')}
                                        </label>
                                        <input
                                            name="email"
                                            id="email"
                                            className="form-control"
                                            value={user.email}
                                            onChange={(e) => this.handleChange(e, user.id)}
                                        />
                                        {this.state.showEmailErrors && !user.isValid && (
                                            <div className="error-message">
                                                {t('onboarding.step_4.email_incorrect')}
                                            </div>
                                        )}
                                    </div>
                                    <div className="onboarding-add-user-field">
                                        <label htmlFor="domain" className="form-label">
                                            {t('onboarding.step_4.select_domains')}
                                        </label>
                                        <ReactSelect
                                            options={options}
                                            isSearchable={false}
                                            onChange={(value) =>
                                                this.onChangeSelect(user.id, value)
                                            }
                                            blurInputOnSelect={true}
                                            classname="mr-10"
                                            isMulti
                                        />
                                    </div>

                                    <div className="onboarding-add-user-btns">
                                        {arr.length !== 1 && (
                                            <button onClick={() => this.deleteUserFileds(user.id)}>
                                                -
                                            </button>
                                        )}
                                        {i === arr.length - 1 && showPluseBtn && (
                                            <button
                                                className="onboarding-add-user-btns-add"
                                                onClick={this.addUserFileds}
                                            >
                                                +
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        {this.state.message && (
                            <div className={`onboarding-message-${this.state.message_tags}`}>
                                {this.state.message}
                            </div>
                        )}
                    </div>
                </div>
                <div className="onboarding-container-item-body-footer">
                    <div className="d-flex">
                        <button
                            className="onboarding-skip-btn"
                            onClick={() => this.props.handleBack()}
                        >
                            {t('onboarding.back')}
                        </button>
                        <button
                            className="onboarding-btn-next"
                            onClick={() => this.onSubmit(save)}
                            disabled={this.state.loading || disabled}
                        >
                            {this.state.loading && <Loading onlyPreloader />}
                            {this.getName(save)}
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(AddUsers);
